import React from 'react'
import HandleMarkup from '@src/components/HandleMarkup'
import { Link } from '@src/components/Link'

interface MapAttributeValuesProps {
  values: string[]
  className?: string | ''
  url?: string
}

const AttrComponent = (props) =>
  props.href ? (
    <Link {...props}>
      <a>{props.value}</a>
    </Link>
  ) : (
    <HandleMarkup {...props} />
  )

const MapAttributeValues: React.FC<MapAttributeValuesProps> = ({
  values,
  className,
  url,
}) => {
  if (!Array.isArray(values) || values.length === 0) {
    return <span className={className}>&mdash;</span>
  }

  if (values.length > 1) {
    const joinedValues = values.join(', ')
    return (
      <AttrComponent value={joinedValues} className={className} href={url} />
    )
  }

  return <AttrComponent value={values[0]} className={className} href={url} />
}

export default MapAttributeValues
